import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getProduct } from './productCatalog';
import GaProductPage from './GaProductPage';
import DmProductPage from './DmProductPage';

export default function Products() {
  const location = useLocation();
  const product = getProduct(location.pathname.split('/')[2], new URLSearchParams(location.search).get('tab'));
  if (!product) return <Navigate to="/products/story" replace />;
  return product.source === 'contentUsage' ? <DmProductPage product={product} /> : <GaProductPage />;
}
